import React from 'react';
import { principles } from '../../data/site';
import { Eyebrow } from '../ui/Eyebrow';
export function Principles() {
  return <section className="bg-ink text-cream-light" data-id="element-90" data-mp="1zv7afv0yr5r2">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-91" data-mp="24tqutqzws9hb">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-92" data-mp="24vlive6h8hpm">
          <div data-id="element-93" data-mp="28wnihw4b2vs4">
            <Eyebrow className="text-stone" data-id="element-94" data-mp="28wf2hvcvzacp">What Republic stands on</Eyebrow>
            <p className="mt-6 font-serif text-4xl leading-[1.06] md:text-[3.5rem]" data-id="element-95" data-mp="2dtdy6ic77pd0">
              More choice is better health for all.
            </p>
          </div>

          <ul className="flex flex-col divide-y divide-cream/20" data-id="element-96" data-mp="2njgqshfer1at">
            {principles.map(principle => <li key={principle.name} className="grid gap-2 py-6 first:pt-0 sm:grid-cols-[10rem_1fr] sm:gap-8" data-id="element-97" data-mp="2si1ooa76t8w3">
                <h3 className="font-serif text-2xl text-cream-light" data-id="element-98" data-mp="31jrhnkgpwfvz">{principle.name}</h3>
                <p className="max-w-xl text-base leading-relaxed text-cream/70" data-id="element-99" data-mp="31hezp7aym5ix">
                  {principle.detail}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}